import { render, staticRenderFns } from "./MyPrize.vue?vue&type=template&id=5e06e5ee&scoped=true&"
import script from "./MyPrize.vue?vue&type=script&lang=js&"
export * from "./MyPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06e5ee",
  null
  
)

export default component.exports